import { useCallback } from 'react';

import FilterFieldsContext from './FilterFieldsContext';

export const MultiFieldsFilterProvider = ({
  children,
  compared,
  fieldsCount,
  onToggleFields,
}) => {
  const getFilterFields = useCallback(
    ({ name, depends }) =>
      [...new Array(fieldsCount)].reduce(
        (acc, _, index) => [
          ...acc,
          {
            path: `${index}.${name}`,
            ...(depends
              ? {
                  dependsFields: depends.map((dependsName) => ({
                    name: dependsName,
                    path: `${index}.${dependsName}`,
                  })),
                }
              : null),
            getPathByName: (name) => `${index}.${name}`,
            basePath: index ? acc[0].path : null,
            collectionPath: `${index}`,
          },
        ],
        []
      ),
    [fieldsCount]
  );

  return (
    <FilterFieldsContext.Provider
      value={{ getFilterFields, compared, fieldsCount, onToggleFields }}
    >
      {children}
    </FilterFieldsContext.Provider>
  );
};
